/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const ShippingType = {
  COLLECTION: 'COLLECTION',
  COURIER: 'COURIER',
  SERVICE_POINT: 'SERVICE_POINT',
  PARCEL_LOCKER: 'PARCEL_LOCKER',
} as const;

export type ShippingType = typeof ShippingType[keyof typeof ShippingType];
